import ReceiptHiddenSection from './ReceiptHiddenSection';
import { KoobBadge, KoobInputNumber, KoobParagraph, KoobTitle } from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function ReceiptContentMargin({
  markup = { value: 0, isPercent: true },
  setMarkup,
}) {
  const { t } = useTranslation('trips');

  const updateGlobalMarkup = (newValues) => {
    const updatedMarkup = {
      ...markup,
      ...newValues,
    };
    if (setMarkup) {
      setMarkup(updatedMarkup);
    }
  };

  return (
    <ReceiptHiddenSection className="mt-3">
      <KoobTitle size="md">
        <div className="flex space-x-3 items-center">
          <div>{t('receipt.markup.title')}</div>
          <KoobBadge>{t('receipt.optional')}</KoobBadge>
        </div>
      </KoobTitle>

      <div className="mt-3 flex justify-between">
        <KoobParagraph size="sm">
          {t('receipt.markup.description')}
        </KoobParagraph>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={markup.isPercent}
            onChange={(event) =>
              updateGlobalMarkup({ isPercent: event.target.checked })
            }
          />
          <p className="text-sm">{t('receipt.markup.usePercentMargin')}</p>
        </div>
      </div>

      <div className="my-3">
        <KoobInputNumber
          min={0}
          value={markup.value}
          emptyValue={0}
          onValueChange={(value) => updateGlobalMarkup({ value: value ?? 0 })}
          placeholder={t('receipt.markup.valuePlaceholder')}
        />
      </div>
    </ReceiptHiddenSection>
  );
}
